import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AdminCategories = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        ক্যাটাগরি পরিচালনা
      </Typography>
      <Paper sx={{ p: 4, textAlign: 'center', mt: 3 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          ক্যাটাগরি পরিচালনা পেজ
        </Typography>
        <Typography variant="body1" color="text.secondary">
          এই পেজটি শীঘ্রই সম্পূর্ণ হবে।
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdminCategories;

